const model = require('./model.json');
const config = require('./SASSY_v1_config');

export class SASSY {
  constructor(){
    //create an in-memory map of responses from the SASSY model
    this.responses = new Map(model.map( (response) => {
      let {Qnum1, Qnum2, Qnum3, Qnum4, Segment} = response;
      return [`${Qnum1}${Qnum2}${Qnum3}${Qnum4}`, Segment]
    }));
  }

  computeSegment({Question1, Question2, Question3, Question4}){
    //given a user response, return appropriate segment from the model
    return this.responses.get(`${Question1}${Question2}${Question3}${Question4}`);
  }

  responseTextToValue(responseText, questionNumber) {
    //translate responses like "Extremely worried" to integer values
    //as required by the model
    if(typeof responseText === "number"){
      return responseText;
    }
    //clean up any extraneous whitespace from submitted response text
    const response = responseText.trim();
    const { questions } = config;
    const { choices } = questions[questionNumber];
    const values = new Map( choices.map( c => [c.text, c.value]) )
    return values.get(response);
  }
}

// module.exports = {SASSY}